import { Component } from 'react';
import MediaQuery from 'react-responsive';
import Sticky from 'react-stickydiv';
import Hero from 'components/Hero';
import Intro from 'components/Intro';
import SectionHeader from 'components/SectionHeader';
import SectionList from 'components/SectionList';
import Participants from 'components/Participants';
import Social from 'components/Social';
import MessageList from 'components/MessageList';
import Aside from 'components/Aside';
import Modal from 'components/Modal';
import _ from 'lodash';
import { breakpointSmallTo, breakpointLargeFrom } from 'config';
import styles from './styles.css';

export default class Chrome extends Component {
	constructor(props) {
		super(props);

		this.state = {
			sectionIndex: 0,
			aside: null,
			modal: null
		};

		this.handleSectionChange = this.handleSectionChange.bind(this);
		this.handlePaneToggle = this.handlePaneToggle.bind(this);
	}

	handleSectionChange(sectionIndex) {
		this.setState({sectionIndex, aside: null});

		// Ensure scroll position is set to top of message list
		window.scrollTo(0, this.refs.container.offsetTop);
	}

	handlePaneToggle(key, data) {
		const toggle = !!data || !this.state[key];
		const keyData = toggle ? data : null;

		this.setState({[key]: keyData});
	}

	render() {
		const asideShown = !!this.state.aside;
		const modalShown = !!this.state.modal;
		const handleAsideToggle = _.curry(this.handlePaneToggle)('aside');
		const handleModalToggle = _.curry(this.handlePaneToggle)('modal');

		return (
			<div className={styles.chrome}>
				<Hero />

				<MediaQuery maxWidth={breakpointSmallTo}>
					<Intro theme="dark" />
				</MediaQuery>

				<div ref="container" className={styles.container}>
					<MediaQuery maxWidth={breakpointSmallTo}>
						<SectionHeader sectionIndex={this.state.sectionIndex}
							onSectionChange={this.handleSectionChange} />
					</MediaQuery>

					<MediaQuery minWidth={breakpointLargeFrom}>
						<div className={styles.aside}>
							<Sticky className="sticky">
								<SectionList sectionIndex={this.state.sectionIndex}
									onSectionChange={this.handleSectionChange} />

								<Participants
									activeAside={this.state.aside}
									onParticipantClick={handleAsideToggle} />

								<Social />
							</Sticky>
						</div>
					</MediaQuery>

					<MessageList key={this.state.sectionIndex}
						sectionIndex={this.state.sectionIndex}
						hasAside={asideShown}
						onMessageBodyClick={handleAsideToggle}
						onMessageImageClick={handleModalToggle}
						onSectionChange={this.handleSectionChange} />

					<Aside {...this.state.aside}
						isShown={asideShown}
						onCloseClick={() => this.handlePaneToggle('aside')} />

					<Modal {...this.state.modal}
						isShown={modalShown}
						onCloseClick={() => this.handlePaneToggle('modal')} />

				</div>
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./components/Chrome/index.js
 **/